import type { SectionId } from "@/features/journal-title-sections";

export interface TitleSectionConfig {
  id: SectionId;
  title: string;
  anchorId: string;
}

export const titleSectionsConfig: TitleSectionConfig[] = [
  {
    id: "journals-info",
    title: "Информация об объекте",
    anchorId: "journals-info",
  },
  {
    id: "developer-company",
    title: "Сведения о застройщике, эксплуатирующей организации или региональном операторе",
    anchorId: "developer-company",
  },
  {
    id: "tec-customer-company",
    title: "Технический заказчик",
    anchorId: "tec-customer-company",
  },
  {
    id: "documentation-permission",
    title: "Разрешение на строительство",
    anchorId: "documentation-permission",
  },
  {
    id: "documentation-contractor-company",
    title: "Лицо, осуществляющее подготовку проектной документации",
    anchorId: "documentation-contractor-company",
  },
  {
    id: "designer-supervisions",
    title: "Авторский надзор",
    anchorId: "designer-supervisions",
  },
  {
    id: "documentation-examination",
    title: "Сведения о положительном заключении экспертизы проектной документации",
    anchorId: "documentation-examination",
  },
  {
    id: "building-contractor-company",
    title: "Лицо, осуществляющее строительство",
    anchorId: "building-contractor-company",
  },
  {
    id: "other-developers",
    title: "Другие лица, осуществляющие строительство, их уполномоченные представители",
    anchorId: "other-developers",
  },
];

